import { Component, ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { Utilityservice } from '../../utility/utilityservice.service';
import { GlobalMessage } from '../../utility/modals';
import { LazyLoadEvent, MenuItem, SortEvent } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ExceldownloadComponent } from '../../directives/exceldownload/exceldownload.component';
import { LocationtypeService } from './locationtype.service';
import { LocationtypemodalComponent } from '../../directives/locationtypemodal/locationtypemodal.component';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';
@Component({
  selector: 'app-locationtype',
  templateUrl: './locationtype.component.html',
  styleUrls: ['./locationtype.component.css']
})
export class LocationtypeComponent {
  @ViewChild('dt') dt: any;
  cols: any[];
  rowsize: number = 10;
  options = [{ label: 10, value: 10 }];
  _selectedColumns: any[];
  customsort: boolean = true;
  showcount: number = 0;
  hidecount: number = 0;
  items: MenuItem[] = [];
  locationtypelistarray: Array<any> = [];
  paginatorArray = [];
  commonScrollHeight = '';
  locationlist: any;
  excel_paragraph = '';
  message: GlobalMessage = new GlobalMessage()
  ref: DynamicDialogRef | undefined;
  exceldownloadModal = false;
  currentPageIndex: number = 0;
  public totalRecords: number = 0;
  labelName = "";
  tablecount: number = 0;
  searchTerm: string = ''; 

  constructor(
    private utilityservice: Utilityservice, private LocationtypeService: LocationtypeService, public dialogService: DialogService,
    public PagehelpmodalService: PagehelpmodalService
  ) {
    this.excel_paragraph = this.message.downloadexcel_text;
  }
  handlePageChange(event: any) {
    this.rowsize = event.rows;
    this.currentPageIndex = event.first;
  }
  dynamiccols() {
    this.cols = [
      { field: 'locationmodelid', header: this.labelName+' ID', type: 'text', sort: false, width: '1px !important', isChecked: true, class: 'headerid' },
      { field: "locationmodelname", header: this.labelName+" Name", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdby", header: "Created By", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "createdon", header: "Created On", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' },
      { field: "activeflag", header: "Status", type: 'text', sort: false, width: '20px', isChecked: true, class: 'otherheader' }

    ]
    this._selectedColumns = this.cols;
    this.utilityservice.headerObservable.next(this.cols);
    this.showcount = 4;
    this.hidecount = 2;
  }

  ngOnInit() {
    this.commonScrollHeight = this.utilityservice.scrollHeight;
    this.getConfiguration();
    this.getAllData();
    //this.dynamiccols();
  }

  getAllData() {
    const currentPageSize = this.rowsize;

    this.LocationtypeService.getData().subscribe({
      next: (data: any) => {
        this.locationlist = data;
        this.locationtypelistarray = data.map(item => ({ ...item, isSelect: false }));

        this.options = this.utilityservice.getOptionDropdown(data.length);
        this.paginatorArray = this.options.map(e => e.value);

        if (!this.paginatorArray.includes(currentPageSize)) {
          this.paginatorArray.push(currentPageSize);
          this.paginatorArray.sort((a, b) => a - b);
        }

        this.rowsize = currentPageSize;
        this.totalRecords = this.locationlist.length;
        this.locationlist = data.count ?? data.length;

        setTimeout(() => {
          if (this.dt) {
            this.dt.first = this.currentPageIndex;

          }
        }, 0);
      },
      error: (error) => {
        const timestamp = new Date().toLocaleString();
        Swal.fire({
          title: error.error?.error || "Error",
          text: `This error occurred at: ${timestamp}`,
          icon: "error",
        });
      }
    });
  }

  customSort(event: SortEvent) {

    event.data.sort((data1, data2) => {
      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = 0;

      const isDate = (date) => !isNaN(Date.parse(date));

      if (value1 == null && value2 != null) result = -1;
      else if (value1 != null && value2 == null) result = 1;
      else if (value1 == null && value2 == null) result = 0;
      else if (typeof value1 === 'string' && typeof value2 === 'string') {
        if (isDate(value1) && isDate(value2)) {
          const date1 = new Date(value1);
          const date2 = new Date(value2);
          result = date1 < date2 ? -1 : date1 > date2 ? 1 : 0;
        } else {
          result = value1.localeCompare(value2);
        }
      } else {
        result = value1 < value2 ? -1 : value1 > value2 ? 1 : 0;
      }
      return event.order * result;
    });

  }
  show(title, data) {
    let details = {};
    if (title === 'Modify Location Type') {
      this.LocationtypeService.getModify(data.locationmodelid).subscribe((res: any) => {
        if (res.length === 0) { 
          Swal.fire({
            icon: 'error',
            title: 'Data Error',
            text: 'Data is null',
          });
        } else {
          details = res;
          this.ref = this.dialogService.open(LocationtypemodalComponent, {
             header: 'Modify '+this.labelName,
            width: '40vw',
            height: 'auto',
            data: { title: title, datas: details,labelName:this.labelName },
            contentStyle: { overflow: 'auto' },
            baseZIndex: 100
          });
          this.ref.onClose.subscribe(() => {
            this.getAllData();
          });
        }
      })
    } else {
      details = {};
      this.ref = this.dialogService.open(LocationtypemodalComponent, {
        header: title,
        width: '40vw',
        height: 'auto',
        data: { title: title, datas: details,labelName:this.labelName },
        contentStyle: { overflow: 'auto', },
        baseZIndex: 100
      });
      this.ref.onClose.subscribe((res) => {
        this.getAllData();
      });
    }
  }

  excelDownload() {
    this.LocationtypeService.getExcelData().subscribe((response: Blob) => {
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url; 
      a.download = this.labelName+'-Data.xlsx';
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      this.exceldownloadModal = false;
      Swal.fire('File downloaded successfully! ', '', 'success');
    }, error => {
      Swal.fire('Something went wrong', '', 'error');
    });
  }

  getConfiguration(): void {
    this.LocationtypeService.getConfiguration().subscribe(
      (response) => {
        if (response && response.length > 0) {
          this.labelName = response[0]?.locationTypeLabel;

          this.dynamiccols();
        }
      },
      (error) => {
        console.error('Error fetching configuration:', error);

        this.dynamiccols();
      }
    );
  }
  cleanRegExp(str: string): string {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  highlight(input: string, searchstring: string | number): string {
    if (!searchstring) return input;
    const safeText = String(input ?? '');
    const safeSearch = this.cleanRegExp(String(searchstring));
    const re = new RegExp(safeSearch, 'gi');
    return safeText.replace(re, match => `<span class="highlightsearch">${match}</span>`);
  }
}
